/**
 * Coup de pouce, Attendu 1223 « trouver un dénominateur commun à deux
 * fractions pour les additionner, les soustraire ou les comparer » (3e,
 * Multiples et diviseurs, l. 787). Seconde passe 3e (2026-09-13).
 *
 * La réponse de 1223 est LE DÉNOMINATEUR (un nombre), pas le résultat :
 * les pages de 1097 (4e, « le même dénominateur d'abord ») montrent
 * exactement ce geste, une par cas, avec les mêmes sacrifiés importés par
 * gen_1223. Trois pages reprises telles quelles, la page « Même
 * dénominateur » écartée (rien à trouver) :
 *   « L'un est un multiple » (2/3 + 1/6 : 6 est dans la table de 3),
 *   « Aucun lien » (2/5 + 1/4 : 5 × 4 = 20),
 *   « Un nombre des deux tables » (5/6 + 3/4 : 12).
 */
import cp1097 from './1097';

const PAGES = cp1097.flash_texte_trou_saisie.pages.filter((p) => p.titre !== 'Même dénominateur');
if (PAGES.length !== 3) throw new Error('cp1223 : trois pages de 1097 attendues');

const AIDE = { pages: PAGES };

const CP_1223 = {
    flash_texte_trou_saisie: AIDE,
    commun_qcm_unique: AIDE,
    commun_tableau_vf: AIDE,
};

export default CP_1223;
